import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable,throwError, BehaviorSubject } from 'rxjs';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import { GlobalService } from './../core/global.service';
import { BidInstruction, BidInstructionSearchParams, PaginationParams, BidInstructionChangeLog, BidInstructionChangeLogSearchParams } from './models';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class ManageBidInstructionService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  };

  // stateCode: BehaviorSubject<string> = new BehaviorSubject(null);
  // trusteeId: BehaviorSubject<string> = new BehaviorSubject(null);

  constructor(private _http: HttpClient, private _global: GlobalService) { 

  }
/*
  setStateCode(statedata: string) {
    this.stateCode.next(statedata);
  }
  getStateCode(): Observable<string> {
    return this.stateCode.asObservable();
  }
*/


  getBidInstruction(pagination?: PaginationParams, bidInstructionSearchParams?: BidInstructionSearchParams): Observable<any> {
    const api = (<any>_GlobalNS).api.bidInstruction.search;

    let params = new HttpParams();

    if (pagination) {
      params = params.set('offset', pagination.offset.toString())
      .set('pageSize', pagination.pageSize.toString())
      .set('sortValue', pagination.sortValue)
      .set('sortDir', pagination.sortDir);
    }
    
    if ( bidInstructionSearchParams.StateCode && bidInstructionSearchParams.StateCode.length > 0 ) {
      params = params.set('stateCode', bidInstructionSearchParams.StateCode.join(','));
    }

    if ( bidInstructionSearchParams.TrusteeId && bidInstructionSearchParams.TrusteeId.length > 0 ) {
      params = params.set('trusteeId', bidInstructionSearchParams.TrusteeId.join(','));
    }

    return this._http.get<any>(`${api}`, {params});
  }

  getStates(): Observable<any> {
    const api = (<any>_GlobalNS).api.allStates;
    let params = new HttpParams();

    return this._http.get<any>(`${api}`, {params}) 
              .pipe(
                map((response) => {return this.formatStateforAddScreen(response)}),
                catchError(error => {return throwError(error)})
    );      
  }

  formatStateforAddScreen(response) {
    let data = response.data;
    let states = [];
    let tempArray: any = {};
    data.map((items) => {
      tempArray = {
        label: items.StateName,
        value: items.StateCode,
        StateName:  items.StateName,
        StateCode: items.StateCode
      }
      states.push(tempArray);
    })
    return states;
  }

  getAvailableTrustees(stateObj,excludeTrusteeList): Observable<any> {
    const api = (<any>_GlobalNS).api.bidInstruction.availableTrustees;
    let params = new HttpParams();
    if(excludeTrusteeList){
      params = params.set('stateCode', stateObj);
    }

    return this._http.get<any>(`${api}`, {params});
  }

  getStatesForMangeScreen(): Observable<any> {
    const api = (<any>_GlobalNS).api.allStates;
    let params = new HttpParams();

    return this._http.get<any>(`${api}`, {params})
    .pipe(
        map((response) => {return this.formatState(response)}),
        catchError(error => {return throwError(error)})
    );    
  }

  formatState(response) {
    let data = response.data;
    let states = [];
    let tempArray: any = {};
    data.map((items) => {
      tempArray = {
        label: items.StateName,
        value: items.StateCode
      }
      states.push(tempArray);
    })
    return states;
  }

  getAvailableTrusteesForMangeScreen(): Observable<any> {
    const api = (<any>_GlobalNS).api.bidInstruction.availableTrustees;
    let params = new HttpParams();

    return this._http.get<any>(`${api}`)
    .pipe(
      map((response) => {return this.formatTrustee(response)}),
      catchError(error => {return throwError(error)})
    );    
  }

  formatTrustee(response){
    let data = response.data;
    let trusteeArray = [];
    let tempArray: any = {};
    data.map((items) => {
      tempArray = {
        label: items.TrusteeName,
        value: items.TrusteeId
      }
      trusteeArray.push(tempArray);
    })
    return trusteeArray;
  }

  createFileDownloadRequest(BidMatrixId?: any): Observable<any> {
    const api = (<any>_GlobalNS).api.bidInstruction.download;
    let params = new HttpParams();
    if (BidMatrixId && BidMatrixId > 0) {
      params = params.set('BidMatrixId', BidMatrixId);
    }
    return this._http.get<any>(`${api}`, {params});  
  }

  downloadBidInstructionFile(BidMatrixId?: any): any {
    let stInfo = {};
    stInfo['success'] = false;
    return new Promise( resolve => {
      this.createFileDownloadRequest(BidMatrixId)
        .subscribe((fileData): any => {
            const fileName = 'TestInstructionFile.docx';
            const json = atob(fileData.data[0].Data);
            const blob = this.transformFileContent(json);
              
            if (window.navigator && window.navigator.msSaveOrOpenBlob) { //--- Alternate solution for createObjectURL(blob) in IE
              window.navigator.msSaveOrOpenBlob(blob, fileName);
            } else {
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = fileName;
              a.click();
              window.URL.revokeObjectURL(url);
            }            
        },
        error => {
          stInfo['success'] = false;
          stInfo['message'] = 'Internal Error: Couldnot download the requested file.';
          resolve(stInfo);
        },
        () => {
          console.log('done');
        });
    });
  }

  //-- Converts base64 file content to Blob
  transformFileContent(byteString) {  
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], { type: "octet/stream" });
  }

  save(BidInstructionPayload: BidInstruction, uploadedFile: any): Observable<any> {
    const api = (<any>_GlobalNS).api.bidInstruction.create;
    const eqrf = this._global.find((<any>_GlobalNS).paths.eqrf);

    //-- Set content type and mime type
    let headers = new HttpHeaders();
    headers.set('Content-Type', null);
    headers.set('Accept', "multipart/form-data");

    let params = new HttpParams();

    //-- set all params in a form structure
    const formData: FormData = new FormData();  
    for (let formField in BidInstructionPayload) {
      formData.append(formField, BidInstructionPayload[formField]);
    }
    formData.append('BidInstructionFile', uploadedFile[0], uploadedFile[0].name);
    formData.append('BidInstructionFileSize', uploadedFile[0].size);
    
    return this._http.post<any>(`${api}&eqrf=${eqrf}`, formData,  { params, headers });
  }

  // updateBidInstruction(BidInstructionPayload: BidInstruction): Observable<any> {
  //   const api = (<any>_GlobalNS).api.bidInstruction.update;
  //   const eqrf = this._global.find((<any>_GlobalNS).paths.eqrf);

  //   return this._http.post<any>(`${api}&eqrf=${eqrf}`, BidInstructionPayload, this.httpOptions);
  // }


  updateBidInstruction(BidInstructionPayload: BidInstruction, uploadedFile?: any): Observable<any> {
    const api = (<any>_GlobalNS).api.bidInstruction.update;
    const eqrf = this._global.find((<any>_GlobalNS).paths.eqrf);
    const formData: FormData = new FormData();
    let headers = new HttpHeaders();
    headers.set('Content-Type', null);
    headers.set('Accept', "multipart/form-data");
    let params = new HttpParams(); 

    if(uploadedFile && uploadedFile.length > 0){
      //-- set all params in a form structure
      for (let formField in BidInstructionPayload) {
        formData.append(formField, BidInstructionPayload[formField]);
      }
      formData.append('BidInstructionFile', uploadedFile[0], uploadedFile[0].name);
      formData.append('BidInstructionFileSize', uploadedFile[0].size);
      return this._http.post<any>(`${api}&eqrf=${eqrf}`, formData, { params, headers });
    }else{
      
       //-- set all params in a form structure
      for (let formField in BidInstructionPayload) {
        formData.append(formField, BidInstructionPayload[formField]);
      }
      return this._http.post<any>(`${api}&eqrf=${eqrf}`, formData, { params, headers });
    }
    
  }

  delete(BidMatrixId :number){
    const api = (<any>_GlobalNS).api.bidInstruction.delete;
    const eqrf = this._global.find((<any>_GlobalNS).paths.eqrf);
    const payload ={};
    if (BidMatrixId && BidMatrixId > 0) {
      payload['BidMatrixId'] = BidMatrixId;
      return this._http.post<any>(`${api}&eqrf=${eqrf}`, payload, this.httpOptions);
    }
  }

  getSelectorsData(): Observable<any>{
    const api = (<any>_GlobalNS).api.bidInstruction.changeLogSelectors;
    return this._http.get<any>(`${api}`); ;
  }

  getChangeLogData(changeLogParams:BidInstructionChangeLogSearchParams): Observable<any> {
    const api = (<any>_GlobalNS).api.bidInstruction.changeLog;
    let params = new HttpParams();
    params = params.set('StateCode', changeLogParams.StateCode)
                    .set('ChangedBy', changeLogParams.ChangedBy)
                    .set('TrusteeId', changeLogParams.TrusteeId)
                    .set('FromDate', changeLogParams.FromDate)
                    .set('ToDate', changeLogParams.ToDate)
                    .delete('ChangedBy', '')
                    .delete('TrusteeId', '')
                    .delete('FromDate', '')
                    .delete('ToDate', '')
                    .delete('StateCode','');
    return this._http.get<any>(`${api}`,{params});
  }

  getBidInstructionQueueData(): Observable<any> {
    const api = (<any>_GlobalNS).api.bidInstruction.bidInstructionQueue;
    return this._http.get<any>(`${api}`)
          .pipe(
            map((response) => {return this.formatBidQueueData(response.data)}),
            catchError(error => {return throwError(error)})
          );  
  }

  formatBidQueueData(data) {
    const url = (<any>_GlobalNS).routes.property.propertyPage;
    let bidQueData = [];
    let tempArray: any = {};
    data.map((item) => {
      tempArray = {
        Loan: item.Loan,
        TaskName: item.TaskName,
        Status: item.Status,
        PropertyId: item.PropertyId,
        propertyUrl: `${url}&property_id=${item.PropertyId}`
      }
      bidQueData.push(tempArray);
    })
    return bidQueData;
  }

}
